import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditLocation } from '../models/Locations/audit-location';
import { BasicResult } from '../models/basic-result';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { map, Observable } from 'rxjs';
import { NewLocationWizardRequest } from '../models/Locations/new-location-wizard-request';
import { NewLocationWizardResult } from '../models/Locations/new-location-wizard-result';

@Injectable({
  providedIn: 'root'
})
export class LocationManagementService {

  
  constructor(private httpClient: HttpClient) {
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: 'response' as 'response',
    responseType: 'json' as const,
    withCredentials: true,
  };
  submitLocationEdit(updatedLocation:AuditLocation): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}locations/savelocationedit`,updatedLocation, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  getRemovedLocations(): Observable<AuditLocation[]> {
    return this.httpClient.get<AuditLocation[]>(`${environment.apiUrl}locations/getremovedlocations`, this.httpOptions).pipe(
      map((res:any) => (res.body ?? []).map((location: AuditLocation) => new AuditLocation(location)))
    );
  }
  reactivateLocation(locationID: number): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}locations/reactivatelocation`, locationID, this.httpOptions).pipe(
      map((res:any) => new BasicResult(res.body!))
    );
  }
  createLocationWizard(request: NewLocationWizardRequest): Observable<NewLocationWizardResult> {
    return this.httpClient.post<NewLocationWizardResult>(`${environment.apiUrl}locations/wizard/createlocation`, request, this.httpOptions).pipe(
      map((res: any) => new NewLocationWizardResult(res.body!))
    );
  }
  getAllLocationsToAssignAudit(): Observable<AuditLocation[]> {
    return this.httpClient.get<AuditLocation[]>(`${environment.apiUrl}locations/getlocationaudits`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  
}
